module.exports = __webpack_public_path__ + "static/scouting_web_ipad-06cac95d7275e1efd4ccb30822ff90c9.png";